module.exports = __webpack_public_path__ + "static/media/5.e2dc8ff9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.jpg
// module id = 792
// module chunks = 1